import React, { useState } from 'react';
import { Button } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import ShareResultsDialog from './ShareResultsDialog';  // <-- NEW

function ShareResultsButton({
  userData,
  analysisData,
  disabled = false,
  ...rest
}) {
  const [open, setOpen] = useState(false);              // <-- NEW

  return (
    <>
      {/* the button itself */}
      <Button
        variant="contained"
        color="primary"
        startIcon={<ShareIcon />}
        disabled={disabled}
        onClick={() => setOpen(true)}                    // <-- NEW
        {...rest}
      >
        Share&nbsp;Results
      </Button>

      {/* modal dialog */}
      <ShareResultsDialog                           // <-- NEW
        open={open}
        onClose={() => setOpen(false)}
        userData={userData}
        analysisData={analysisData}
      />
    </>
  );
}

export default ShareResultsButton;
